class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    // Lollypop: the parent title inside <summary> is a real link. With a pointer that can hover, the submenu
    // opens on hover so children stay reachable while a click on the title navigates to the parent collection.
    this.finePointer = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);
    this.openedByHover = false;
    if (this.finePointer) {
      this.addEventListener('mouseenter', this.onHoverIn.bind(this));
      this.addEventListener('mouseleave', this.onHoverOut.bind(this));
      // A click on the caret while the menu is open because of hover must not close it under the pointer.
      this.summary.addEventListener('click', (event) => {
        if (this.openedByHover && this.mainDetailsToggle.hasAttribute('open')) {
          event.preventDefault();
          this.openedByHover = false;
        }
      });
    }
    const parentLink = this.summary.querySelector('.header__menu-item-link');
    if (parentLink) {
      parentLink.addEventListener('click', (event) => {
        if (!this.finePointer && !this.mainDetailsToggle.hasAttribute('open')) {
          // Touch (no hover): the first tap on the title opens the submenu; a second tap follows the link.
          event.preventDefault();
          this.mainDetailsToggle.setAttribute('open', '');
          this.summary.setAttribute('aria-expanded', true);
          return;
        }
        // Let the browser follow the link; do not treat the click as a disclosure toggle.
        event.stopPropagation();
      });
    }
  }

  onHoverIn() {
    clearTimeout(this.hoverTimer);
    if (this.mainDetailsToggle.hasAttribute('open')) return;
    this.openedByHover = true;
    this.mainDetailsToggle.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', true);
  }

  onHoverOut() {
    clearTimeout(this.hoverTimer);
    this.hoverTimer = setTimeout(() => {
      if (this.contains(document.activeElement)) return;
      this.openedByHover = false;
      this.close();
    }, 180);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
